import 'regenerator-runtime/runtime'
import {
  SurveyInstanceExecutionServicePromiseClient,
  Answer,
  setRequest,
} from '@utils/index'

type Params = Answer.AsObject

const {
  REACT_APP_QUERY_HOST = 'https://staging.pandolink.com',
  REACT_APP_QUERY_PORT = '443',
} = process.env

export const createAnswer = async (params: Params, accessToken: string) => {
  const service = new SurveyInstanceExecutionServicePromiseClient(
    `${REACT_APP_QUERY_HOST}:${REACT_APP_QUERY_PORT}`
  )

  const request = setRequest(new Answer(), params)

  const result = await service.createAnswer(request, {
    authorization: `Bearer ${accessToken}`,
  })

  return result
}
